import { render } from "./TemplateActions.vue?vue&type=template&id=363823ee&ts=true"
import script from "./TemplateActions.vue?vue&type=script&lang=ts"
export * from "./TemplateActions.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2026745536/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__